const validation = {
  required: "必須項目です。",
  minLength: "{{min}}文字以上で入力してください。",
  maxLength: "{{max}}文字以下で入力してください。",
  invalidURL: "URLの形式が正しくありません。",
  noCredit: "クレジットが不足しています。",
};
export default validation;
